import dynamic from 'next/dynamic';

const Login = dynamic(() => import('./Login'), { ssr: true });
export default Login;
